
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import GlossSearchBar from '@/ui/GlossSearchBar.vue';
import { PAGE_DEFAULT_ORIENTATION, PAGE_DEFAULT_PAPER_TYPE } from '@/container';

@Component({
    components: {
        GlossSearchBar,
    },
})
export default class ActionBar extends Vue {
    @Prop({ type: String, required: true })
    public readonly paperType!: string;

    @Prop({ type: String, required: true })
    public readonly orientation!: string;

    @Prop({ type: Boolean, required: true })
    public readonly canDelete!: boolean;

    public internalPaperType = PAGE_DEFAULT_PAPER_TYPE;
    public internalOrientation = PAGE_DEFAULT_ORIENTATION;

    public onFileNew(): void {
        this.$emit('new');
    }

    public onFileOpen(): void {
        this.$emit('open');
    }

    public onFileSave(): void {
        this.$emit('save', false);
    }

    public onFileSaveAs(): void {
        this.$emit('save', true);
    }

    public onFileDelete(): void {
        this.$emit('delete');
    }

    public onShowPreview(): void {
        this.$emit('preview');
    }

    public onGeneratePdf(): void {
        this.$emit('generate-pdf');
    }

    public onSelectPaper(type: string): void {
        this.internalPaperType = type;
    }

    public onSelectOrientation(type: string): void {
        this.internalOrientation = type;
    }

    @Watch('paperType')
    public onPaperTypeChanged(paperType: string) {
        if (paperType !== this.internalPaperType) {
            this.internalPaperType = paperType;
        }
    }

    @Watch('orientation')
    public onOrientationChanged(orientation: string) {
        if (orientation !== this.internalOrientation) {
            this.internalOrientation = orientation;
        }
    }

    @Watch('internalPaperType', { immediate: true })
    public onInternalPaperTypeChanged(paperType: string) {
        this.$emit('configuration-changed', { paperType });
    }

    @Watch('internalOrientation', { immediate: true })
    public onInternalOrientationChanged(orientation: string) {
        this.$emit('configuration-changed', { orientation });
    }
}
